const getters = {
  getShippingAddress(state) {
    return state.shippingAddress
  },
  getCheckoutSummary(state) {
    return state.orderSummary
  },
  getReferralCode(state) {
    return state.referralCode
  }
}

export default getters
